/**
 * @module common/containers/project
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import {
  fetchProjectIfNeeded, fetchInvoice, getProject, updateProjectLocal
} from 'project/ducks/project';
import { fetchAttachments } from 'pap/ducks/project';
import { fetchCustomContracts } from 'common/ducks/contract';
import { fetchWrapupsIfNeeded } from 'project/ducks/wrapup';
import Project from 'project/components/project';
import { getProjectIdFromUrl } from 'project/utils';

Project.need = [
  params => fetchProjectIfNeeded({ projectId: getProjectIdFromUrl(params) }),
  fetchCategoriesIfNeeded
];

function mapStateToProps(state, { params }) {
  const projectID = getProjectIdFromUrl(params);

  return {
    projectID,
    project: getProject(state),
    projectSlug: params.pageSlug,
    subcategorySlug: params.subcategory,
    showingAwardsModal: state.project.awards.showingAwardsModal,
    showingFeaturesModal: state.project.features.showingFeaturesModal,
    showingStatsModal: state.project.projectPage.project.showingStatsModal,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  const actions = {
    fetchProjectIfNeeded,
    fetchCategoriesIfNeeded,
    fetchAttachments,
    fetchCustomContracts,
    fetchWrapupsIfNeeded,
    fetchInvoice,
    clearProject: partial(updateProjectLocal, {}),
  };

  return bindActionCreators(actions, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Project));



// WEBPACK FOOTER //
// ./project/containers/project.jsx